import { useState, useEffect, useCallback } from "react";
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import {motion} from "framer-motion";
import { NavLink } from 'react-router-dom';
import logoprodejce from "../images/prodejcetemplate.png";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";
import icon from "../images/prodejcetemplate.png";
import builder from "../utils/builderWithLocale";
import { GoGlobe } from "react-icons/go";
import { MdEmail } from "react-icons/md";
import { BsFillTelephoneFill } from "react-icons/bs";
import ProdejceLoading from "../website/prodejci-loader";
import { getLocalizedText, getMapCenter, getMapZoom } from '../utils/textLocalization';
import { getCurrentLocale } from "../utils/builderLocale";


function App() {
  // Get localized text
  const searchPlaceholderText = getLocalizedText('dealers.search_placeholder');
  const searchingText = getLocalizedText('dealers.searching');
  const notFoundText = getLocalizedText('dealers.not_found');
  const dealerText = getLocalizedText('dealers.dealer');
  const dealersTitle = getLocalizedText('dealers.title');
  const dealersSearchSubtitle = getLocalizedText('dealers.search_subtitle');

  // Use country-specific map defaults
  const [position, setPosition] = useState(getMapCenter());
  const [zoom, setZoom] = useState(getMapZoom());
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const [allCoordinatesAdress, setAllCoordinatesAdress] = useState({});

  const [points, setPoints] = useState([])
  
function checkAllAddresses(addresses) {
  if (!Array.isArray(addresses)) return [];

  return addresses.map((addr) => {
    if (typeof addr !== 'string') return addr;
    let s = addr.replace(/^\s+/, '');
    s = s.replace(/\s+,/g, ',');
    s = s.replace(/,\s*/g, ', ');
    s = s.replace(/\s+/g, ' ').trim();

    return s;
  });
}

async function fetchAllCoordinates(addresses) {
  const newAddresses = checkAllAddresses(addresses);

  try {
    const response = await fetch("https://ridley-bikes.cz/getCords", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newAddresses),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    return await response.json();
  } catch (error) {
    console.error("Chyba při načítání souřadnic:", error);
    return {};
  }
}

const convertToPoints = useCallback(async (data) => {
  try {
    
    const addressList = data.map(item => {
      let psc = item.data.psc;
      // Add space if PSC is 5 digits without space (like 12345 -> 123 45)
      if (psc && psc.length === 5 && !psc.includes(' ')) {
        psc = psc.slice(0, 3) + ' ' + psc.slice(3);
      }
      return `${item.data.adresa}, ${item.data.mesto}, ${psc}`;
    });
    
    
    const allCoordinates = await fetchAllCoordinates(addressList);
    setAllCoordinatesAdress(allCoordinates);
    const result = data.map(item => {
      const adresa = item.data.adresa?.trim();
      const mesto = item.data.mesto?.trim();
      const psc = item.data.psc?.trim();
      const zeme = item.data.zeme?.trim();
      
      const fullAddress = `${adresa}, ${mesto}, ${psc}`;
      //const fullAddress = ${item.data.adresa}, ${item.data.mesto}, ${item.data.psc};    <- Původní systém na adresy

      const coordinates = allCoordinates[fullAddress] || [0, 0];
      if (coordinates[0] === 0 && coordinates[1] === 0) {
        console.log(`Souřadnice pro adresu "${fullAddress}" nebyly nalezeny.`);
      }

      /*
        Původní return:

        return {
          id: item.id,
          image: logoprodejce,
          name: item.data.nazev,
          adresa1: item.data.adresa,
          adresa2: `${item.data.mesto} ${item.data.psc}`,
          coordinates: coordinates,
          email: item.data.email,
          telefon: item.data.telefon,
          web: item.data.web,
          zeme: item.data.zeme
        };
      */

      return {
        id: item.id,
        image: logoprodejce,
        name: item.data.nazev,
        adresa1: adresa,
        adresa2: `${mesto} ${psc}`,
        coordinates: coordinates,
        email: item.data.email,
        telefon: item.data.telefon,
        web: item.data.web,
        zeme: zeme
      };
    });

    console.log(result);
    
    return result;
  } catch (error) {
    console.error("Chyba při konverzi bodů:", error);
    return [];
  }
}, [setAllCoordinatesAdress]);

  // Remove this redundant mapping - points already have coordinates
  // const vendorsWithCoordinates = points.map((point) => {
  //   const vendor = points.find((vendor) => vendor.id === point.id);
  //   return {
  //     ...vendor,
  //     coordinates: point.coordinates,
  //   };
  // });

  function MapClickHandler() {
    const map = useMap();
    
    useEffect(() => {
      map.on('focus', () => {
        map.scrollWheelZoom.enable();
      });
      
      map.on('blur', () => {
        map.scrollWheelZoom.disable();
      });
      
      map.on('click', () => {
        if (!map.scrollWheelZoom.enabled()) {
          map.scrollWheelZoom.enable();
        }
      });
      
      // Return a cleanup function
      return () => {
        map.off('focus');
        map.off('blur');
        map.off('click');
      };
    }, [map]);
    
    return null;
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  const normalizeText = (text = "") =>
    text
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9\s]/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  const levenshteinDistance = (a = "", b = "") => {
    const matrix = Array.from({ length: a.length + 1 }, () => Array(b.length + 1).fill(0));

    for (let i = 0; i <= a.length; i += 1) {
      matrix[i][0] = i;
    }

    for (let j = 0; j <= b.length; j += 1) {
      matrix[0][j] = j;
    }

    for (let i = 1; i <= a.length; i += 1) {
      for (let j = 1; j <= b.length; j += 1) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        matrix[i][j] = Math.min(
          matrix[i - 1][j] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j - 1] + cost
        );
      }
    }

    return matrix[a.length][b.length];
  };

  const getNameSimilarityScore = (query, name) => {
    const normalizedQuery = normalizeText(query);
    const normalizedName = normalizeText(name);

    if (!normalizedQuery || !normalizedName) {
      return 0;
    }

    if (normalizedName.includes(normalizedQuery) || normalizedQuery.includes(normalizedName)) {
      return 1;
    }

    const distance = levenshteinDistance(normalizedQuery, normalizedName);
    const maxLength = Math.max(normalizedQuery.length, normalizedName.length);

    if (maxLength === 0) {
      return 0;
    }

    return 1 - distance / maxLength;
  };

  const getDealerMatchesByName = (query) => {
    if (!query || !points.length) {
      return [];
    }

    const MEDIUM_MATCH_THRESHOLD = 0.68;

    return points
      .map((point) => {
        const normalizedQuery = normalizeText(query);
        const searchableText = normalizeText(`${point.name} ${point.adresa1} ${point.adresa2}`);
        const score = getNameSimilarityScore(query, point.name);
        const hasDirectTextMatch = searchableText.includes(normalizedQuery);

        return {
          point,
          score,
          hasDirectTextMatch,
        };
      })
      .filter(({ score, hasDirectTextMatch }) => hasDirectTextMatch || score >= MEDIUM_MATCH_THRESHOLD)
      .sort((a, b) => {
        if (a.hasDirectTextMatch !== b.hasDirectTextMatch) {
          return a.hasDirectTextMatch ? -1 : 1;
        }
        return b.score - a.score;
      })
      .map(({ point }) => point);
  };

  const searchLocation = useCallback(async () => {
    if (!debouncedSearchQuery) return;
    setLoading(true);
    setError(false);

    setSelectedVendors([]);

    const dealersByName = getDealerMatchesByName(debouncedSearchQuery);
    if (dealersByName.length > 0) {
      setPosition(dealersByName[0].coordinates);
      setZoom(15);
      setSelectedVendors(dealersByName);
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(debouncedSearchQuery)}`
      );
      const data = await response.json();
      if (data.length > 0) {
        const searchPos = [parseFloat(data[0].lat), parseFloat(data[0].lon)];

        const closestPoints = points
          .filter((point) => point.coordinates && point.coordinates[0] !== 0 && point.coordinates[1] !== 0)
          .map((point) => ({
            point,
            distance: getDistance(searchPos, point.coordinates),
          }))
          .sort((a, b) => a.distance - b.distance)
          .slice(0, 5)
          .map(({ point }) => point);

        if (closestPoints.length > 0) {
          setPosition(closestPoints[0].coordinates);
          setZoom(15);
          setSelectedVendors(closestPoints);
          setLoading(false);
          return;
        }

        setError(true);
        setLoading(false);
      } else {
        setError(true)
        setLoading(false)
      }
    } catch (error) {
      setError(true)
      setLoading(false)
    }
  }, [debouncedSearchQuery, points]);

  useEffect(() => {
    if (debouncedSearchQuery) {
      searchLocation();
    } else {
      setPosition(getMapCenter());
      setZoom(getMapZoom());
      setLoading(false);
    }
  }, [debouncedSearchQuery, points, allCoordinatesAdress, searchLocation]);

  useEffect(() => {
    setLoading(true);
    document.title = "Ridley | " + dealersTitle
    
    const loadDealers = async () => {
      try {
        const data = await builder.getAll("prodejci", { limit: 300 });

        const pointsData = await convertToPoints(data);

        const currentLocale = getCurrentLocale();
        let filteredPoints = [];

        if (currentLocale === 'cs') {
          filteredPoints = pointsData.filter(item => item.zeme === "Česká republika");
        } else if (currentLocale === 'sk') {
          filteredPoints = pointsData.filter(item => item.zeme === "Slovensko");
        } else if (currentLocale === 'pl') {
          filteredPoints = pointsData.filter(item => item.zeme === "Polsko");
        } else if (currentLocale === 'hu') {
          filteredPoints = pointsData.filter(item => item.zeme === "Maďarsko");
        } else {
          // Default fallback
          filteredPoints = pointsData;
        }
        
        setPoints(filteredPoints);
      } catch (error) {
        console.error("Chyba při načítání prodejců:", error);
      } finally {
        setLoading(false);
      }
    };
    
    loadDealers();
  }, [convertToPoints, dealersTitle]);

const getDistance = (coord1, coord2) => {
  const R = 6371000;

  const coord2Lat = Array.isArray(coord2) ? coord2[0] : coord2?.lat;
  const coord2Lng = Array.isArray(coord2) ? coord2[1] : coord2?.lng;

  if (coord2Lat === undefined || coord2Lng === undefined) {
    return Infinity;
  }

  const φ1 = coord1[0] * (Math.PI / 180);
  const φ2 = coord2Lat * (Math.PI / 180);
  const Δφ = (coord2Lat - coord1[0]) * (Math.PI / 180);
  const Δλ = (coord2Lng - coord1[1]) * (Math.PI / 180);

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) *
    Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
};


  const customIcon = new Icon({
    iconUrl: icon,
    iconSize: [35, 35],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32],
  });

  function MapUpdater() {
    const map = useMap();
    if (position) {
      map.setView(position, zoom);
    }
    return null;
  }

  return (
    <>
      <motion.div key="loading" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
        <section id="prodejci" className="text-center scrollto clearfix prodejci">
          <div className="row clearfix">
            <div className="section-heading">
              <h3 className="barlow-semibold">{dealersTitle}</h3>
              <h2 className="section-title white-title">{dealersSearchSubtitle}</h2>
            </div>
          </div>
        </section>

        {loading && points.length === 0 ? (
          <>
           <ProdejceLoading />
          </>
        ) : (
          <div className="prodejce-container">
          <MapContainer center={position} zoom={zoom} className="prodejci-iframe" scrollWheelZoom={false}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            {points.filter(vendor => vendor.coordinates && vendor.coordinates[0] !== 0 && vendor.coordinates[1] !== 0).map((vendor) => (
              <Marker key={vendor.id} position={vendor.coordinates} icon={customIcon}>
                <Popup>
                  <div className="map-popup">
                  <img src={vendor.image} alt={vendor.name} />
                  <h1>{vendor.name}</h1>
                  <h2>{vendor.adresa1}</h2>
                  <h2>{vendor.adresa2}</h2>
                  <NavLink to={"https://"+vendor.web} target='_blank' rel="noopener noreferrer">{dealerText}</NavLink>
                  </div>
                </Popup>
              </Marker>
            ))}
            <MapUpdater />
            <MapClickHandler />
          </MapContainer>

          <div className="prodejci-menu">
            <input placeholder={searchPlaceholderText} type="text" value={searchQuery} onChange={(e) => {setSearchQuery(e.target.value); setLoading(true)}} />
            <div>
              {searchQuery !== "" ? (
                <>
                  {loading ? (
                    <span className="prodejci-search-loading">{searchingText}</span>
                  ) : (
                    <>
                      {error ? (
                        <span className="prodejci-search-loading">{notFoundText}</span>
                      ) : (
                        <>
                          {selectedVendors.length > 0 && (
                            <div className="all-vendors-list">
                              {selectedVendors.map((vendor) => (
                                <p key={vendor.id} className="single-vendor-result">
                                  <img src={vendor.image} alt={vendor.name} />
                                  <h1>{vendor.name}</h1>
                                  <h2>{vendor.adresa1}</h2>
                                  <h2>{vendor.adresa2}</h2>
                                  <h2><BsFillTelephoneFill /> {vendor.telefon}</h2>
                                  <h2><MdEmail /> {vendor.email}</h2>
                                  <h2><GoGlobe /> <NavLink to={"https://"+vendor.web} target='_blank' rel="noopener noreferrer">{vendor.web}</NavLink></h2>
                                </p>
                              ))}
                            </div>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              ) : (
                <div className="all-vendors-list">
                  {points.map((prodejce, index) => (
                    <p key={prodejce.id}>
                      <img src={prodejce.image} alt={prodejce.name} />
                      <h1>{prodejce.name}</h1>
                      <h2>{prodejce.adresa1}</h2>
                      <h2>{prodejce.adresa2}</h2>
                      <h2><BsFillTelephoneFill /> {prodejce.telefon}</h2>
                      <h2><MdEmail /> {prodejce.email}</h2>
                      <h2><GoGlobe /> <NavLink to={"https://"+prodejce.web} target='_blank' rel="noopener noreferrer">{prodejce.web}</NavLink></h2>
                    </p>
                  ))}
                </div>
              )}
            </div>
          </div>
          </div>
        )}
      </motion.div>
    </>
  );
}

export default App;
